// Server Jsend

interface IjsendResponse {
  status: 'success' | 'fail' | 'error';
}

export interface IjsendOkResponse<T> extends IjsendResponse {
  data: T;
}
export interface IjsendErrorResponse<T> extends IjsendResponse {
  status: 'error';
  message: string;
}
export interface IjsendFailResponse<T> extends IjsendResponse {
  status: 'fail';
  code?: number;
  data: { [index: string]: string };
}

export function isJsendResponse(response: unknown): response is IjsendResponse {
  return !!response && typeof response === "object" && 'status' in response;
}

export function isJsendOk<T>(
  response: unknown
): response is IjsendOkResponse<T> {
  return (
    isJsendResponse(response) &&
    "data" in response
  );
}

export function isJsendError<T>(response: unknown): response is IjsendErrorResponse<T> {
  return (
    isJsendResponse(response) &&
    "status" in response &&
    response.status === "error" &&
    "message" in response &&
    typeof response.message === "string"
  );
}

export function isJsendFail<T>(response: unknown): response is IjsendFailResponse<T> {
  return (
    isJsendResponse(response) &&
    "status" in response &&
    response.status === "fail" &&
    "data" in response &&
    typeof response.data === "object"
  );
}